





























import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { ITemplateCategory } from "@/models/templates";
import eventsMap from "@/components/app/global/timelineComponent/events";
import { INotificationHook } from "@/models/notifications";
import {
  ITemplateProvider,
  ITemplateProviderMethods
} from "@/models/providers/templates";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

@Component({
  components: {
    Treeselect
  }
})
export default class HooksField extends Vue {
  // Inject
  @Inject({ from: "templateProvider" })
  public templateProvider!: () => ITemplateProvider;

  @Inject({ from: "templateProviderMethods" })
  public $templateMethods!: ITemplateProviderMethods;

  // Props

  @Prop({ required: true })
  public value!: INotificationHook["id"][];

  @Prop({ required: true })
  public selectedCategory!: ITemplateCategory;

  @Prop({ default: false })
  public isDisabled!: string;

  // Data
  public selectedHooks: INotificationHook["id"][] = [];

  // Life-cycle methods
  public created() {
    this.setSelectedHooks();
    this.$watch("value", this.setSelectedHooks);
  }

  // Computed

  public get $templateData() {
    return this.templateProvider();
  }

  public get lockedHookIds() {
    return (
      this.$templateData.template?.mappings
        ?.filter(i => i.locked)
        ?.map(i => i.hook_id) || []
    );
  }

  public get options() {
    const options: any[] = [];
    this.$_.forEach(this.$templateData.categories, category => {
      if (
        !this.$templateData.isNew &&
        this.selectedCategory?.id !== category.id
      ) {
        // Show only from same category
        return;
      }
      const enabledHookIndex = this.$_.findIndex(category.hooks, [
        "notifiable",
        true
      ]);
      if (!category.hooks.length || enabledHookIndex === -1) {
        return;
      }
      const isDisabled = !!(
        this.selectedCategory?.id && this.selectedCategory.id !== category.id
      );
      const option: any = {
        id: `category-${category.id}`,
        label: category.name,
        isDisabled: isDisabled,
        children: []
      };
      this.$_.forEach(category.hooks, hook => {
        option.children.push({
          id: hook.id,
          label: (eventsMap?.[hook.code]?.name || hook.name) as string,
          isDisabled:
            this.isDisabled ||
            isDisabled ||
            this.lockedHookIds.includes(hook.id) ||
            !hook.notifiable
        });
      });
      options.push(option);
    });

    return options;
  }

  // Methods

  public setSelectedHooks() {
    this.selectedHooks = this.$templateData.hooks
      .filter(i => this.value?.includes(i.id))
      .map(i => i.id);
  }

  public onInput(value) {
    if (this.isDisabled) return;
    this.selectedHooks = value;
    this.$emit("input", value);
  }
}
